import { defineStore } from 'pinia';

const STORAGE_KEY = 'eskrag_recently_viewed_v1';
const MAX_ITEMS = 15;

const RECHARGE_SUBCAT_IDS = [157, 158, 159, 160, 162, 163];
const RECHARGE_CAT_IDS = [33, 34, 35];

const isRechargeProduct = (item) => {
  if (!item) return false;
  if (item.type === 'physical') return false;
  const id = parseInt(item.id);
  const catId = parseInt(item.categorie_id || item.category_id);
  return RECHARGE_SUBCAT_IDS.includes(id) || RECHARGE_CAT_IDS.includes(catId);
};

const loadInitialItems = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(i => !isRechargeProduct(i)) : [];
  } catch (e) {
    console.error('Failed to load recently viewed items from storage', e);
    return [];
  }
};

export const useRecentlyViewedStore = defineStore('recentlyViewed', {
  state: () => ({
    items: loadInitialItems()
  }),

  getters: {
    hasItems: (state) => state.items.filter(i => !isRechargeProduct(i)).length > 0,
    all: (state) => state.items.filter(i => !isRechargeProduct(i)),
    subcategories: (state) => state.items.filter(i => i.type === 'subcategory' && !isRechargeProduct(i)),
    physicalProducts: (state) => state.items.filter(i => i.type === 'physical')
  },

  actions: {
    trackView(item) {
      if (!item || !item.id) return;
      if (isRechargeProduct(item)) return;

      const type = item.type || 'subcategory';
      const id = item.id;

      // Filter out existing occurrence to bump to top
      const filtered = this.items.filter(i => !(i.id === id && i.type === type));

      const entry = {
        id,
        type,
        title: item.title || item.libelle || item.model_name || 'Product',
        brand: item.brand || item.category_name || item.category?.name || '',
        image: item.image || item.main_image || '',
        image_url: item.image_url || '',
        slug: item.slug || '',
        category_slug: item.category_slug || (item.category?.slug) || 'digital',
        price: item.price !== undefined ? item.price : null,
        min_price: item.min_price !== undefined ? item.min_price : null,
        min_price_da: item.min_price_da !== undefined ? item.min_price_da : null,
        average_rating: item.average_rating || 0,
        ratings_count: item.ratings_count || 0,
        viewed_at: Date.now()
      };

      this.items = [entry, ...filtered].slice(0, MAX_ITEMS);
      this.saveToStorage();
    },

    removeItem(id, type) {
      this.items = this.items.filter(i => !(i.id === id && i.type === type));
      this.saveToStorage();
    },

    clearAll() {
      this.items = [];
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        console.error('Failed to clear recently viewed storage', e);
      }
    },

    saveToStorage() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      } catch (e) {
        console.error('Failed to persist recently viewed storage', e);
      }
    }
  }
});
